	<template>

		<MainLayout>
			<div class="container">
				<div class="box">
					<b-overlay :show="loading" no-wrap></b-overlay>
					<b-breadcrumb>
						<b-breadcrumb-item  @click.stop="$router.push('/sales-channels/')" >
							<span > <md-icon icon="arrow_back"></md-icon> Regresar</span>
						</b-breadcrumb-item>
					</b-breadcrumb>

					<b-card title="" class="mb-2 summary rounded-1"  >
						<b-card-text>
							<h6 class="text-capitalize">
								<b-badge :variant="variantStatus">
									{{ saleChannelCurrent.status}}
								</b-badge>
							</h6>
							<p><strong>Channel Name:</strong> {{ saleChannelCurrent.name }} </p>
							<p><strong>Description:</strong> {{ saleChannelCurrent.description }}</p>
						</b-card-text>
					</b-card>

					<b-card no-body>
						<b-tabs vertical pills card class="d-flex flex-column flex-lg-row" id="tabs-sales-channels">

							<b-tab title="Rate Plans">
								<div class="">
									<div class=" text-right mr-3">
										<b-button variant="success" @click="addRatePlan" class="mb-3">Add Rate Plan</b-button>
									</div>
									<AjaxTable
										id="rate-plans-index-list"
										:filters="ratePlans.filters"
										:columns="ratePlans.fields"
										resource="rate-plans"
									>
										<template v-slot:cell(actions)="row">
											<div class="text-center">
												<b-button  type="button" size="sm" class="mr-1" variant="success" @click="openPricesModule(row.item)" v-b-tooltip.hover title="Manage prices">
													<md-icon icon="price_change" />
												</b-button>
												<b-button  type="button" size="sm" class="mr-1" variant="info" @click="editRatePlan(row.item)" v-b-tooltip.hover title="Edit Rate plan">
													<md-icon icon="edit" />
												</b-button>
												<b-button type="button" size="sm" class="mr-1" variant="danger" @click="deleteRatePlan(row.item)" v-b-tooltip.hover title="Delete Rate plan">
													<md-icon icon="delete" />
												</b-button>
											</div>
										</template>
									</AjaxTable>
								</div>
							</b-tab>
						</b-tabs>
					</b-card>

					<b-modal v-model="showRatePlanModal" :title="$t('ratePlan.data')" size="xl" hide-footer>
						<formRatePlan
						:ratePlanFor="{for:'salesChannel',id:saleChannelCurrent.id}"
						@submitted="ratePlanFormSubmitted"
						@close="showRatePlanModal=false"
						ref="formRatePlan"
						>
							<template #header-form>
								<div class="mb-1">
									<h4 class="">Sale channel: <b>{{ saleChannelCurrent.name }}</b></h4>
									<hr>
								</div>
							</template>
						</formRatePlan>
					</b-modal>

					<b-modal ref="modal-prices" :title="$t('ratePlan.summary')" size="xl" dialog-class="_modalPricesCustomSize" hide-footer>
						<PricesModule v-if="ratePlans.selectedForPrices" :ratePlanId="ratePlans.selectedForPrices" ></PricesModule>
					</b-modal>
				</div>
			</div>
		</MainLayout>

	</template>

	<script>
	import MainLayout from '../layout/MainLayout.vue'
	import FormRatePlan from './rate-plans/Form.vue';
	import AjaxTable from './../../helpers/AjaxTable.vue'
	import PricesModule from './../../sections/rate-plans/prices/Single'
	export default {
		props: {
			salesChannelId: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				loading:false,
				saleChannelCurrent: {
					id:-1,
					name: '',
					description: '',
					status:'',
				},
				showRatePlanModal: false,
				currentRatePlan: {
					id: null,
					name: ''
				},
				ratePlans:{
					filters:{salesChannelId: this.salesChannelId},
					fields:[
						{ key: 'id', label: 'ID' },
						{ key: 'name', label: 'Rate Plan Name' },
						{ key: 'zonedArea.name', label: this.$t("ratePlan.operationArea") },
						{ key: 'currency', label: this.$t("ratePlan.currency") },
						{ key: 'startDate', label: this.$t("ratePlan.startDate") },
						{ key: 'endDate', label: this.$t("ratePlan.endDate")  },
						{ key: 'description', label: this.$t("global.description") },
						{ key: 'actions', label: 'Actions' }
					],
					selectedForPrices:null
				}
			};
		},

		components: { MainLayout , FormRatePlan,AjaxTable,PricesModule},
		methods: {
			fetchSaleChannel(){
				return this.$root.api.get(`/sales-channels/${this.salesChannelId}`).then( res => {
					return res.data;
				}).catch(this.$root.handleRequestError);
			},
			async init(){
				this.loading= true;
				this.saleChannelCurrent = await this.fetchSaleChannel();
				this.loading = false;
			},
			ratePlanFormSubmitted(){
				this.$root.$emit('bv::refresh::table', 'rate-plans-index-list')
			},
			editRatePlan(item){
				this.showRatePlanModal = true;
				setTimeout(() => {
					let component = this.$refs["formRatePlan"];
					component.loadModel(item.id)
				}, 0);
			},
			deleteRatePlan(item) {
				this.$bvModal
				.msgBoxConfirm(this.$t("ratePlan.confirmDelete",{ratePlanName:item.name.toUpperCase()}), {
					title: this.$t("warnings.okToContinue"),
					size: "md",
					buttonSize: "md",
					okVariant: "danger",
					okTitle: this.$t("global.yes")+", "+this.$t("warnings.continue"),
					cancelTitle: "Cancel",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				})
				.then(value => {
					if (value === true) {
						this.$root.api.delete(`/rate-plans/${item.id}`).then(() => {
							this.$root.showAlert(this.$t('global.registerDeleted'),{variant:'success'})
							this.ratePlanFormSubmitted();
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
				.catch(err => {
					console.log(err);
					// An error occurred
				});
			},
			addRatePlan() {
				this.currentRatePlan = { id: null, name: '', price: '' };
				this.showRatePlanModal = true;
			},
			openPricesModule(item){
				this.ratePlans.selectedForPrices = item.id;
				this.$refs["modal-prices"].show();
			}
		},
		computed:{
			variantStatus(){
				let variant = "secondary"
				switch(this.saleChannelCurrent.status){
					case "active":
						variant= "success"
					break;
					case "inactive":
						variant= "warning"
					break;
				}
				return variant;
			}
		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesCategoriesOpts']})
			this.init();
		}
	};
	</script>

	<style scoped>
	.mt-4 {
		margin-top: 1.5rem;
	}
	.mt-3 {
		margin-top: 1rem;
	}

	.summary p{
		margin-bottom: auto;
	}
	.summary .card-body{
		padding-bottom: .5rem;
	}

	</style>
	<style>
	@media (max-width: 1920px) {
		._modalPricesCustomSize {
			/* Your styles here */
			max-width: 95vw !important;
			/* Add any other styles you need */
		}
	}

	@media (max-width: 992px) {/* IN MOBILE IS IN ROW THE TABS */
		.flex-column {
			display: flex ;
			flex-direction: row ;
			overflow-x: auto;
		}
	}

	#tabs-sales-channels.flex-column .nav-link{
		max-width: 40vw;
		width: max-content !important;
	}

	</style>
